import { Component } from '@angular/core';

@Component({
    selector: 'app-admin-wrapper',
    templateUrl: './admin-wrapper.component.html',
    styleUrls: ['./admin-wrapper.component.sass'],
    standalone: false
})
export class AdminWrapperComponent {

}
